/**
 * V37.60 — Source de verite unique pour la presentation LEGALCOOP cote frontend.
 *
 * Doit etre reproduite a l'identique dans :
 *  - page vitrine /dispositifs-btp
 *  - back-office /admin/legalcoop
 *  - widget membre/cooper MesServicesLegalcoop
 *  - modals de demande / paiement
 *
 * INTERDIT : tout libellé de type « assistance » juridique. Utiliser exclusivement :
 *  - "LEGALCOOP — Revue de conformité CCMI"
 *  - "Forfait Revue de conformité CCMI"
 */
export const LEGALCOOP_OFFICIAL_DEFINITION = (
  "LEGALCOOP est un espace de revue documentaire d\u2019aide à la conformité CCMI, " +
  "proposé dans le cadre du programme COPPAM hébergé par OBJECTIF SCOP OUTREMER " +
  "SCIC SAS. Il permet au demandeur de transmettre un projet ou contrat CCMI, " +
  "d\u2019obtenir une analyse documentaire assistée, puis une revue humaine par un " +
  "juriste ou un intervenant habilité dans le workflow interne. Le service vise " +
  "à identifier les points de vigilance, les pièces manquantes et les éléments " +
  "à compléter avant validation humaine. Il ne constitue pas une consultation " +
  "juridique formelle ni un avis juridique définitif."
);

export const LEGALCOOP_DISCLAIMERS = [
  "Revue documentaire d\u2019aide à la conformité — ne constitue pas un avis juridique définitif.",
  "Pour une consultation juridique formelle, contactez un avocat ou un professionnel habilité.",
  "Aucun changement de statut CCMI sans décision humaine explicite.",
];

export const LEGALCOOP_COMMERCIAL_NAME = "LEGALCOOP — Revue de conformité CCMI";
export const LEGALCOOP_FORFAIT_NAME = "Forfait Revue de conformité CCMI";
